import React from 'react'
import { Truck, MapPin } from 'react-feather'
import PillToggle from './PillToggle'
import styles from './MapListToggle.module.css'

export default function MapListToggle(props){
  const {
    active,
    mapUrl,
    listUrl,
    ...rest
  } = props

  return (
    <PillToggle
      {...rest}
      pills={[
        {
          text: 'MAP',
          url: mapUrl,
          icon: <MapPin size={11} className={styles.pin} />,
          active: active === 'map',
        },
        {
          text: 'LIST',
          url: listUrl,
          icon: <Truck size={11} />,
          active: active === 'list',
        }
      ]}
    />
  )
}
